import { render } from "./ProductListLayout.vue?vue&type=template&id=cab8c002"
import script from "./ProductListLayout.vue?vue&type=script&lang=js"
export * from "./ProductListLayout.vue?vue&type=script&lang=js"

import "./ProductListLayout.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__